import { Bell }                from 'react-feather';
import { enableNotifications } from '../push';
import OnboardingSection       from './onboarding_section';
import React                   from 'react';
import useNotificationState    from '../hooks/use_notification_state';


export default function NotificationsSection() {
  const notificationState = useNotificationState();

  if (notificationState === null)
    return null;
  else if (notificationState === 'denied')
    return null; // TODO? render OS-specific instructions for enabling notifications
  else
    return <EnableNotifications {...{ notificationState }}/>;
}

function EnableNotifications({ notificationState }) {
  const isCollapsed = notificationState === 'granted';

  return (
    <OnboardingSection className="notifications" collapsed={isCollapsed}>
      <h2>Get notified</h2>
      <div className="not-completed-section">
        <p>
          Turn on notifications to stay in touch with new leads, customer messages, and online reviews.
        </p>
        <div className="actions">
          <button className="button button-fill enable-notifications-button" onClick={enableNotifications}>
            <Bell/>
            <span className="label">Enable notifications</span>
          </button>
        </div>
      </div>
    </OnboardingSection>
  );
}
